@if (visible) {
  <div class="import-geometries-popup-container" [formGroup]="form">
    <div class="table-container">
      <table>
        <thead>
          <tr>
            <th style="min-width: 30px; width:30px">Synlig</th>
            <th style="min-width: 110px; width:110px">Namn</th>
            <th style="min-width: 40px; width:40px">Typ</th>
            <th style="min-width: 200px; width:200px">Importera till</th>
          </tr>
        </thead>
        <tbody>
          <ng-container formArrayName="mappings">
            @for(mapForm of mappings.controls; track mapForm)
              {
              <ng-container [formGroup]="mapForm">
                <tr
                  (mouseenter)="hoverRow(mapForm.controls.id.value, true)"
                  (mouseleave)="hoverRow(mapForm.controls.id.value, false)">
                  <td>
                    <rask-checkbox
                      class="unset-rask"
                      formControlName="visible"
                      (change)="updateVisibleRows(mapForm)"
                    ></rask-checkbox>
                  </td>
                  <td>
                    <a href="javascript: void(0)" [ngbPopover]="popContent" container="body"
                      popoverClass="attributes-popover">
                      {{mapForm.controls.name.value}}
                    </a>
                    <ng-template #popContent>
                      <table>
                        <thead>
                          <tr>
                            <th>Nyckel</th>
                            <th>Värde</th>
                          </tr>
                        </thead>
                        <tbody>
                          @for(attributeForm of mapForm.controls.attributes.controls;
                            track attributeForm){
                            <tr>
                              <td>{{attributeForm.controls.key.value}}</td>
                              <td>{{attributeForm.controls.value.value}}</td>
                            </tr>
                          }
                        </tbody>
                      </table>
                    </ng-template>
                  </td>
                  <td>{{mapForm.controls.typeLabel.value}}</td>
                  <td>
                    @if(isTypePunkt(mapForm.controls.type.value)){
                      <rask-selector
                        popupClass="import-geometries-popup-typeahead"
                        formControlName="destination"
                        [values]="typerPunkt"
                        [formatter]="genericItemFormatter"
                        [viewFormatter]="genericViewFormatter"
                        class="unset-rask"
                        listPlacement="top"
                        [portalToBody]="true">
                      </rask-selector>
                    }
                    @else if(isTypeLinje(mapForm.controls.type.value)){
                    <rask-selector
                      popupClass="import-geometries-popup-typeahead"
                      formControlName="destination"
                      [values]="typerLinje"
                      [formatter]="genericItemFormatter"
                      [viewFormatter]="genericViewFormatter"
                      class="unset-rask"
                      listPlacement="top"
                      [portalToBody]="true">
                    </rask-selector>
                  }
                  @else if(isTypeYta(mapForm.controls.type.value)){
                  <rask-selector
                    popupClass="import-geometries-popup-typeahead"
                    formControlName="destination"
                    [values]="typerYta"
                    [formatter]="genericItemFormatter"
                    [viewFormatter]="genericViewFormatter"
                    class="unset-rask"
                    listPlacement="top"
                    [portalToBody]="true">
                  </rask-selector>
                }
              </td>
            </tr>
          </ng-container>
        }
      </ng-container>
    </tbody>
  </table>
</div>
<div class="import-footer">
  {{summaryText()}}
  <rask-button class="mt-0" color="primary" (click)="onImportClick()">Importera</rask-button>
  <rask-button class="mt-0" color="secondary" (click)="close()">Stäng</rask-button>
</div>
</div>
}